export default "__VITE_PUBLIC_ASSET__38113975__"